var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelMembership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/CancelMembership") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/CancelMembership",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-cancel-membership"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.730000, 11.030000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.66,69.84 L8.69,69.84 C3.89,69.84 3.55271368e-15,65.78 3.55271368e-15,60.77 L3.55271368e-15,9.07 C3.55271368e-15,4.06 3.89,0 8.69,0 L95.61,0 C100.41,0 104.3,4.06 104.3,9.07 L104.3,52.09",
    id: "Path",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#282828",
    cx: 26.29,
    cy: 26.36,
    r: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,46.21 L13.92,46.21 C13.92,39.38 19.45,33.85 26.28,33.85 C33.11,33.85 38.64,39.38 38.64,46.21 L38.65,46.21 Z",
    id: "Path",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 24.8,
    x2: 77.59,
    y2: 24.8,
    id: "Path",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 33.19,
    x2: 77.59,
    y2: 33.19,
    id: "Path",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 42.32,
    x2: 77.59,
    y2: 42.32,
    id: "Path",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.660000, 47.060000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.120000, 17.120000)",
    id: "Path",
    stroke: "#FF7900"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -1.42108547e-14,
    y1: -1.42108547e-14,
    x2: 16.64,
    y2: 16.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.42108547e-14,
    y1: 16.63,
    x2: 16.64,
    y2: -1.42108547e-14
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#282828",
    cx: 25.44,
    cy: 25.44,
    r: 25.44
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelMembership);
export default __webpack_public_path__ + "static/media/cancel_membership.cac3d69bb1f760747298c201873ab4ac.svg";
export { ForwardRef as ReactComponent };